import { Dispatch, FunctionComponent, SetStateAction, useLayoutEffect, useState } from 'react'
import { Box, IconButton, Typography, Link, Divider, MenuItem } from '@material-ui/core'
import {
  PersonAdd,
  ExitToAppOutlined,
  LockOutlined,
  Person,
  SupervisorAccount,
  RateReview,
  VerifiedUser,
  Settings
} from '@material-ui/icons'
import { Logo } from '../logo'
import { BackendUser, UserRoles, PartnerType, AllSearchResult, UserFeedback } from 'common/types'
import { ReactComponent as EventIcon } from 'icons/event.svg'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useThemeSwitch } from 'hooks/theme'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { NavbarDropdownMenu } from 'components/core/actions-menu/NavbarDropdownMenu'
import { Footer, FooterNav } from '../footer'
import { ProfileStatus } from '../profile-status/ProfileStatus'
import { Notifications } from '../notifications/Notifications'
import { ChangePasswordModal } from 'pages/settings/components/ChangePasswordModal'
import { usePasswordChange } from 'pages/settings/hooks/usePasswordChange'
import { InviteFriendsByEmailModal } from 'pages/auth/components/invite-friends/InviteFriendsByEmailModal'
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom'
import { useNotifications } from 'hooks/use-notifications/useNotifications'
import { NotificationDrawer } from 'components/page/notifications/NotificationDrawer'
import { ReactComponent as HomeIcon } from 'icons/home.svg'
import { ReactComponent as NetworkIcon } from 'icons/people.svg'
import { ReactComponent as JobIcon } from 'icons/briefcase-solid.svg'
import { useProfilePercentage } from 'hooks/use-profile-percentage/useProfilePercentage'
import { SearchBar } from 'components/core/search'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useUpdateModePreference } from 'hooks/use-update-mode-preference/useUpdateModePreference'
import { useNotification } from 'hooks/use-notification/useNotification'
import { FeedbackModal } from 'pages/auth/components/feedback/FeedbackModal'
import { useFeedApi } from 'hooks/use-feed-api/useFeedApi'
import { ReactComponent as CompanyIcon } from 'icons/company.svg'
import { ThemeModal } from 'components/core/ThemeModal/ThemeModal'
import { SideNavList } from '../side-nav/SideNavList'
import { PathName } from 'common/types/pathName.types'
import { ModeSwitch } from 'common/atoms/ModeSwitch/ModeSwitch'
import { DEV_ONLY } from 'common/globalConstants'
import { MusicButton } from 'common/atoms/PlayButton/MusicButton'
import { useHexToRGB } from 'hooks/use-hex-to-rgb/useHexToRGB'
import { NavButton } from 'common/atoms/NavButton/NavButton'
import { AccountSettingsGroupItemName } from 'common/types/account-settings-drawer.types'
import { slugify } from 'common/utils/slugify'

export const StyledPageWrapper = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.colors.bgPrimary};
    position: 'relative';
    min-height: '100vh';
  }
`

export const StyledIconButton = styled(IconButton)`
  && {
    margin: 0em 0 0 -0.2em;
    height: 20px;
    align-self: center;
  }
`

export const StyledNavIconButton = styled(IconButton)`
  && {
    border-radius: 6px;
    padding: 6px 12px;
    width: 84px;
    height: 61px;
    display: flex;
    justify-content: center;
    align-items: end;
  }
  &:hover {
    background-color: ${props => useHexToRGB(props.theme.colors.accent, 0.1)} !important;
  }
`

export const NavIconContainer = styled(Box)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5626rem;
    height: 1.5626rem;
  }
`

export const StyledBox = styled(Box)`
  &:hover {
    color: ${props => props.theme.colors.primary} !important;
  }
`

export const StyledMoonIcon = styled(MoonIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`
export const StyledSunIcon = styled(SunIcon)`
  && {
    height: 17px;
    width: 17px;
  }
`

export const StyledExitButton = styled(ExitToAppOutlined)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledLockButton = styled(LockOutlined)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledSettingsIcon = styled(Settings)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledPasswordIcon = styled(VerifiedUser)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledPersonButton = styled(PersonAdd)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledAdminKeyButton = styled(SupervisorAccount)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledUserButton = styled(Person)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledCompanyButton = styled(CompanyIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    stroke: ${props => props.theme.colors.accent1};
    width: 1em;
    height: 1em;
    font-size: 1.5em;
  }
`
export const StyledFeedbackButton = styled(RateReview)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
export const StyledWrapper = styled(({ nopadding, nomargin, ...props }) => <Box {...props} />)<{
  nopadding?: boolean
  nomargin?: boolean
}>`
  && {
    padding: ${props => (props.nopadding ? '0 0' : '1.95em 0 0 0')};
    margin-bottom: ${props => (props.nomargin ? '0' : '6.5%')};
    @media screen and (max-width: ${props => props.theme.breakpoints.large}) {
      padding: 0 0;
      margin-bottom: ${props => (props.nomargin ? '0' : '15%')};
    }
    @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
      padding: 0 0;
      margin-bottom: ${props => (props.nomargin ? '0' : '35%')};
    }
  }
`
export const StyledHomeIcon = styled(HomeIcon)`
  cursor: pointer;
`
export const StyledNetworkIcon = styled(NetworkIcon)`
  cursor: pointer;
`
export const StyledJobIcon = styled(JobIcon)`
  cursor: pointer;
  width: 1.5em;
`

export const StyledEventIcon = styled(EventIcon)<{ active?: boolean }>`
  && {
    fill: ${props => (props.active ? props.theme.colors.primary : props.theme.colors.accent)};
  }
`

export const StyledNavTextBox = styled(Box)``

const StyledDivider = styled(Divider)`
  && {
    background-color: ${props => props.theme.colors.supplementary1};
    width: 100%;
    margin: 10px 0;
  }
`

interface MainContainerProps {
  title: string
  shrinkLogo?: boolean
  hideLogo?: boolean
  stickTopBar?: boolean
  hideActions?: boolean
  user?: BackendUser
  showAvatar?: boolean
  hideFooter?: boolean
  nopadding?: boolean
  hideLinks?: boolean
  showSearch?: boolean
  inviteUsersByEmail?: Function
  stickyFooter?: boolean
  nomargin?: boolean
  setSearchTab?: Dispatch<SetStateAction<number>>
  setPageNum?: Dispatch<SetStateAction<number>>
  setResults?: Dispatch<SetStateAction<AllSearchResult[]>>
  isPostingContent?: boolean
}

export const MainContainer: FunctionComponent<MainContainerProps> = ({
  title,
  shrinkLogo,
  hideLogo,
  stickTopBar,
  hideActions,
  children,
  user,
  hideFooter,
  nopadding,
  nomargin,
  showSearch,
  inviteUsersByEmail,
  stickyFooter,
  setSearchTab,
  setPageNum,
  setResults,
  isPostingContent
}) => {
  const [openSideBar, setOpenSideBar] = useState(false)
  const [showInviteFriends, setShowInviteFriends] = useState(false)
  const [showFeedback, setShowFeedback] = useState<boolean>(false)
  const [overlayTabIndex, setOverlayTabIndex] = useState(0)
  const theme = useTheme()
  const { onLogout, isAuthenticated, backendUser, backendPartner } = useAuth()
  const { mode, switchTheme } = useThemeSwitch()
  const { isDevice, isTablet } = useScreenSizes()
  const { notify } = useNotification()

  const {
    unreadNotifications,
    drawer,
    setDrawer,
    totalNotifications,
    setPage: setNotificationPage,
    page: notificationPage,
    updateNotification,
    setNotifications,
    setTotalNotifications,
    clearNotifications,
    showNotificationAlert,
    handleAlertClick,
    handleStoringLatestNotification
  } = useNotifications(backendUser?.id)
  const { loadingPreference } = useUpdateModePreference()
  const history = useHistory()
  const { pathname } = useLocation()
  const { getProfilePercentage } = useProfilePercentage()
  const { logEventAnalytics } = useAnalytics()

  useLayoutEffect(() => {
    document.title = `${title} | Obsidi`
  }, [title])

  const {
    vDetails,
    setError,
    password,
    setPassword,
    passwordValid,
    setPasswordValid,
    onResetPasswordWithUser,
    passwordChange,
    setPasswordChange,
    showChangePassword,
    setShowChangePassword,
    currentPassword,
    setCurrentPassword,
    handleErrorMessage,
    confirmPassword,
    setConfirmPassword,
    confirmPasswordValid,
    setConfirmPasswordValid,
    onCurrentPasswordChange,
    onPasswordChange,
    onConfirmPasswordChange
  } = usePasswordChange()

  const { createFeedback } = useFeedApi()

  const toggleDrawer = open => {
    setOpenSideBar(open)
  }

  const navbarPadding = () => {
    if ((nopadding && isDevice) || isDevice) {
      return '0 1em'
    }
    return '0'
  }

  const forceUpdate = () => {
    if (pathname === '/feed') {
      window.scrollTo(0, 0)
      window.location.reload()
    }
  }

  const handleAvatarClickTracker = (eventName: string, options?: Record<string, any>) => {
    const partnerLog = {}
    const userLog = {}
    const logData = {}
    if (options && (options['Feedback Category'] || options['Feedback Category'])) {
      logData['Feedback Category'] = options['Feedback Category']
      logData['Attached File'] = options['Attached File']
    }

    if (options && options['Mode Category']) {
      logData['Mode Category'] = options['Mode Category']
    }
    userLog['User ID'] = backendUser?.id
    userLog['Email address'] = backendUser?.username
    if (backendUser?.partnerId) {
      partnerLog['Partner ID'] = backendPartner?.id
      partnerLog['Company Name'] = backendPartner?.name
      partnerLog['Account Type'] = 'Partner'
    } else {
      userLog['Account Type'] = backendUser?.role
    }
    logEventAnalytics(
      backendUser?.partnerId ? 'Partner' : 'Member',
      eventName,
      'mixpanel',
      eventName,
      { ...partnerLog, ...userLog, ...logData },
      backendUser?.id
    )
  }

  return (
    <StyledPageWrapper>
      {!hideLogo && (
        <Box
          bgcolor={theme.colors.supplementary}
          p={navbarPadding()}
          display="flex"
          justifyContent="center"
          top="0"
          zIndex="3"
          position={stickTopBar ? 'sticky' : 'unset'}
          boxShadow={theme.colors.shadowXSmall}
        >
          <Box
            maxWidth="78.3125rem"
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            margin="auto"
            width="100%"
            height="70px"
          >
            <ThemeModal loading={isPostingContent ? isPostingContent : loadingPreference} />
            {isDevice && (
              <Box display="flex" flexDirection="row" width="100%" alignItems="center" justifyContent="space-between">
                <Box width="70%">
                  <SideNavList
                    toggleDrawer={toggleDrawer}
                    inviteUsersByEmail={inviteUsersByEmail}
                    getProfilePercentage={getProfilePercentage(backendUser)}
                  />
                </Box>
                <Box display="flex" alignItems="center" justifyContent="end" gridGap="1rem">
                  <Notifications
                    theme={theme}
                    setDrawer={setDrawer}
                    setTab={setOverlayTabIndex}
                    showAlert={showNotificationAlert}
                    handleClick={handleAlertClick}
                    drawer={drawer}
                  />
                  <NavButton
                    to={PathName.EVENTS}
                    icon={<StyledEventIcon active={pathname === PathName.EVENTS} />}
                    label="Events"
                    height="46px"
                  />
                </Box>
              </Box>
            )}
            {!isDevice && (
              <Box display="flex" alignItems="center" position="relative">
                <Box
                  onClick={() => {
                    const partnerLog = {}
                    const userLog = {}

                    if (backendUser?.partnerId) {
                      partnerLog['Partner ID'] = backendPartner?.id
                      partnerLog['Company Name'] = backendPartner?.name
                      partnerLog['Account Type'] = 'Partner'
                    } else {
                      userLog['Account Type'] = backendUser?.role
                    }
                    logEventAnalytics(
                      backendUser?.partnerId ? 'Partner' : backendUser?.role,
                      'Home page view',
                      'mixpanel',
                      'Home page view',
                      {
                        'User ID': backendUser?.id,
                        ...partnerLog,
                        ...userLog
                      },
                      backendUser?.id,
                      {
                        $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                        $email: backendUser?.username
                      }
                    )
                  }}
                >
                  <Logo pathname={pathname} bright size={shrinkLogo ? 'x-small' : 'small'} />
                </Box>
                {showSearch && (
                  <SearchBar
                    setSearchTab={setSearchTab}
                    setPageNum={setPageNum}
                    setResults={setResults}
                    backendUser={backendUser}
                    isDevice={isDevice}
                    isTablet={isTablet}
                  />
                )}
              </Box>
            )}

            <Box ml="1.25rem">
              <MusicButton />
            </Box>

            {!hideActions && !isDevice && (
              <Box width="100%">
                <Box display="flex" alignItems="center" justifyContent="flex-end" gridGap="1.7em">
                  <StyledNavTextBox>
                    <StyledNavIconButton aria-label="Tea Spot">
                      <NavButton
                        to={PathName.FEED}
                        onClick={() => {
                          const partnerLog = {}
                          const userLog = {}
                          userLog['User ID'] = backendUser?.id
                          if (backendUser?.partnerId) {
                            partnerLog['Partner ID'] = backendPartner?.id
                            partnerLog['Company Name'] = backendPartner?.name
                            partnerLog['Account Type'] = 'Partner'
                          } else {
                            userLog['Account Type'] = backendUser?.role
                          }
                          logEventAnalytics(
                            backendUser?.partnerId ? 'Partner' : 'Member',
                            'Posts viewed',
                            'mixpanel',
                            'Posts viewed',
                            { ...partnerLog, ...userLog },
                            backendUser?.id
                          )
                          forceUpdate()
                        }}
                        icon={
                          <StyledHomeIcon
                            fill={pathname === PathName?.FEED && !drawer ? theme.colors.primary : theme.colors.accent}
                          />
                        }
                        label="Tea Spot"
                      />
                    </StyledNavIconButton>
                  </StyledNavTextBox>
                  <StyledNavTextBox>
                    <StyledNavIconButton aria-label="My Tribe">
                      <NavButton
                        to={PathName.CONNECTIONS}
                        onClick={() => {
                          logEventAnalytics(
                            backendUser?.partnerId ? 'Partner' : backendUser?.role,
                            'View Connections',
                            'both',
                            'View Connections',
                            {
                              'Connection viewer email': backendUser?.username,
                              'Connection viewer ID': backendUser?.id,
                              'Account type': backendUser?.partnerId ? 'Partner' : backendUser?.role
                            },
                            backendUser?.id,
                            {
                              $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                              $email: backendUser?.username
                            }
                          )
                        }}
                        label="My Tribe"
                        icon={
                          <StyledNetworkIcon
                            fill={
                              pathname === PathName?.CONNECTIONS && !drawer ? theme.colors.primary : theme.colors.accent
                            }
                          />
                        }
                      />
                    </StyledNavIconButton>
                  </StyledNavTextBox>
                  <StyledNavTextBox>
                    <StyledNavIconButton aria-label="Jobs">
                      <NavButton
                        to={PathName.PRIVATE_JOBS}
                        onClick={() => {
                          const partnerLog = {}
                          const userLog = {}

                          if (backendUser?.partnerId) {
                            partnerLog['Partner ID'] = backendUser?.partnerId
                            partnerLog['Company Name'] = backendPartner?.name
                          }

                          logEventAnalytics(
                            backendUser?.partnerId ? 'Partner' : backendUser?.role,
                            'Job Page view',
                            'mixpanel',
                            'Job Page view',
                            {
                              'User ID': backendUser?.id,
                              'Email address': backendUser?.username,
                              'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
                              ...userLog,
                              ...partnerLog
                            },
                            backendUser?.id,
                            {
                              $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                              $email: backendUser?.username
                            }
                          )
                        }}
                        icon={
                          <StyledJobIcon
                            fill={
                              pathname === PathName?.PRIVATE_JOBS && !drawer
                                ? theme.colors.primary
                                : theme.colors.accent
                            }
                          />
                        }
                        label="Jobs"
                      />
                    </StyledNavIconButton>
                  </StyledNavTextBox>
                  <Box display="flex" alignItems="center">
                    {isAuthenticated && (
                      <>
                        <Box mr="4em">
                          <StyledNavIconButton aria-label={AccountSettingsGroupItemName.NOTIFICATIONS}>
                            <Notifications
                              theme={theme}
                              setDrawer={setDrawer}
                              setTab={setOverlayTabIndex}
                              showAlert={showNotificationAlert}
                              handleClick={handleAlertClick}
                              drawer={drawer}
                            />
                          </StyledNavIconButton>
                        </Box>
                        <NavbarDropdownMenu
                          title=""
                          icon={
                            <ProfileStatus
                              percentage={getProfilePercentage(backendUser)}
                              avatar={backendUser?.image}
                              name={backendUser?.firstName}
                              onClick={() => handleAvatarClickTracker('Profile menu')}
                            />
                          }
                        >
                          <MenuItem>
                            <StyledIconButton
                              size="small"
                              onClick={() => handleAvatarClickTracker('My Page from Profile menu')}
                            >
                              <Box m="0em" display="flex" flexDirection="row">
                                <StyledUserButton />
                                <Typography variant="body2" component="span">
                                  <Link component={RouterLink} to={'/profile'} style={{ textDecoration: 'none' }}>
                                    <StyledBox color={theme.colors.accent1} m="0 1em">
                                      My Page
                                    </StyledBox>
                                  </Link>
                                </Typography>
                              </Box>
                            </StyledIconButton>
                          </MenuItem>

                          {backendUser?.partnerId && (
                            <MenuItem>
                              <StyledIconButton
                                size="small"
                                onClick={() => handleAvatarClickTracker('Company Page from Profile menu')}
                              >
                                <Box m="0em" display="flex" flexDirection="row">
                                  <StyledCompanyButton />
                                  <Typography variant="body2" component="span">
                                    <Link
                                      component={RouterLink}
                                      to={`/company/${backendUser?.partnerId}`}
                                      style={{ textDecoration: 'none' }}
                                    >
                                      <StyledBox color={theme.colors.accent1} m="0 1em">
                                        {backendPartner?.type == PartnerType.Community
                                          ? 'Community Page'
                                          : 'Company Page'}
                                      </StyledBox>
                                    </Link>
                                  </Typography>
                                </Box>
                              </StyledIconButton>
                            </MenuItem>
                          )}
                          <MenuItem>
                            <StyledIconButton size="small" onClick={() => setShowInviteFriends(true)}>
                              <Box m="0em" display="flex" flexDirection="row">
                                <StyledPersonButton />
                                <Typography variant="body2" component="span">
                                  <StyledBox color={theme.colors.accent1} m="0 1em">
                                    Invite Peeps
                                  </StyledBox>
                                </Typography>
                              </Box>
                            </StyledIconButton>
                          </MenuItem>
                          {backendUser?.role === UserRoles.Admin && (
                            <MenuItem>
                              <StyledIconButton
                                size="small"
                                onClick={() => {
                                  history.push('/admin/home')
                                  const partnerLog = {}
                                  const userLog = {}
                                  userLog['User ID'] = backendUser?.id
                                  if (user?.partnerId) {
                                    partnerLog['Partner ID'] = backendPartner?.id
                                    partnerLog['Company Name'] = backendPartner?.name
                                    partnerLog['Account Type'] = 'Partner'
                                  } else {
                                    userLog['Account Type'] = backendUser?.role
                                  }
                                  logEventAnalytics(
                                    backendUser?.partnerId ? 'Partner' : backendUser?.role,
                                    'Admin Page',
                                    'both',
                                    'Admin Page Clicked',
                                    { ...partnerLog, ...userLog },
                                    backendUser?.id
                                  )
                                }}
                              >
                                <Box m="0em" display="flex" flexDirection="row">
                                  <StyledAdminKeyButton />
                                  <Typography variant="body2" component="span">
                                    <StyledBox color={theme.colors.accent1} m="0 1em">
                                      Administrator
                                    </StyledBox>
                                  </Typography>
                                </Box>
                              </StyledIconButton>
                            </MenuItem>
                          )}
                          <MenuItem>
                            <StyledIconButton
                              size="small"
                              onClick={() => {
                                setShowFeedback(true)
                                handleAvatarClickTracker('Feedback clicks from Profile menu')
                              }}
                            >
                              <Box m="0em" display="flex" flexDirection="row">
                                <StyledFeedbackButton />
                                <Typography variant="body2" component="span">
                                  <StyledBox color={theme.colors.accent1} m="0 1em">
                                    Feedback
                                  </StyledBox>
                                </Typography>
                              </Box>
                            </StyledIconButton>
                          </MenuItem>
                          <MenuItem>
                            <StyledIconButton
                              size="small"
                              onClick={() => {
                                history.push(`/account-settings/${slugify(AccountSettingsGroupItemName.EDIT_PROFILE)}`)
                              }}
                            >
                              <Box m="0em" display="flex" flexDirection="row">
                                <StyledSettingsIcon />
                                <Typography variant="body2" component="span">
                                  <StyledBox color={theme.colors.accent1} m="0 1em">
                                    Account Settings
                                  </StyledBox>
                                </Typography>
                              </Box>
                            </StyledIconButton>
                          </MenuItem>
                          {backendUser?.authType === 'creds' && (
                            <MenuItem>
                              <StyledIconButton
                                size="small"
                                onClick={() => {
                                  setShowChangePassword(true)
                                  handleAvatarClickTracker('Change Password from Profile menu')
                                }}
                              >
                                <Box m="0em" display="flex" flexDirection="row">
                                  <StyledPasswordIcon />
                                  <Typography variant="body2" component="span">
                                    <StyledBox color={theme.colors.accent1} m="0 1em">
                                      Change Password
                                    </StyledBox>
                                  </Typography>
                                </Box>
                              </StyledIconButton>
                            </MenuItem>
                          )}
                          <StyledDivider style={{ cursor: 'default' }} />
                          <MenuItem>
                            <StyledIconButton size="small" onClick={() => onLogout()}>
                              <Box m="0em" display="flex" flexDirection="row">
                                <StyledExitButton />
                                <Typography variant="body2" component="span">
                                  <StyledBox color={theme.colors.accent1} m="0 1em">
                                    Logout
                                  </StyledBox>
                                </Typography>
                              </Box>
                            </StyledIconButton>
                          </MenuItem>
                          <StyledDivider />
                          <Box padding="10px 18px" style={{ display: 'flex', marginLeft: '0' }}>
                            <Typography variant="body2" component="span">
                              <Box color={theme.colors.accent1} m="0.5em 0.3em">
                                Mode:
                              </Box>
                            </Typography>
                            <ModeSwitch
                              mode={mode == 'dark' ? 'light' : 'dark'}
                              onChange={mode => {
                                switchTheme()
                              }}
                            />
                          </Box>
                        </NavbarDropdownMenu>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}
      <StyledWrapper nopadding={nopadding} nomargin={hideFooter || nomargin}>
        {(isDevice || isTablet) && showSearch && isAuthenticated && (
          <Box margin="1em 0em" display="flex" alignItems="center" justifyContent="center">
            <Box display="block">
              <SearchBar
                backendUser={backendUser}
                isDevice={isDevice}
                isTablet={isTablet}
                setSearchTab={setSearchTab}
                setResults={setResults}
                setPageNum={setPageNum}
              />
            </Box>
          </Box>
        )}
        {children}
      </StyledWrapper>
      {!hideFooter && !isDevice && (
        <Box
          display="flex"
          width="100%"
          justifyContent="center"
          position={stickyFooter ? 'sticky' : 'unset'}
          bottom={stickyFooter ? '0' : ''}
          onClick={() => {
            const partnerLog = {}
            const userLog = {}

            userLog['User ID'] = backendUser?.id

            if (backendUser?.partnerId) {
              partnerLog['Partner ID'] = backendPartner?.id
              partnerLog['Company Name'] = backendPartner?.name
              partnerLog['Account Type'] = 'Partner'
            } else {
              userLog['Account Type'] = backendUser?.role
            }
            logEventAnalytics(
              backendUser?.partnerId ? 'Partner' : 'Member',
              'Home page view by Footer',
              'mixpanel',
              'Home page view by Footer',
              { ...partnerLog, ...userLog },
              backendUser?.id
            )
          }}
        >
          <Footer backendUser={backendUser} />
        </Box>
      )}
      {!hideFooter && isDevice && <FooterNav user={backendUser} />}
      <NotificationDrawer
        user={backendUser}
        drawer={drawer}
        setDrawer={setDrawer}
        setNotifications={setNotifications}
        setTotalNotifications={setTotalNotifications}
        theme={theme}
        notifications={unreadNotifications}
        totalNotifications={totalNotifications}
        isDevice={isDevice}
        isTablet={isTablet}
        updateNotification={updateNotification}
        tabIndex={overlayTabIndex}
        setTabIndex={setOverlayTabIndex}
        backendUser={backendUser}
        clearNotifications={clearNotifications}
        setNotificationPage={setNotificationPage}
        notificationPage={notificationPage}
        handleStoringLatestNotification={handleStoringLatestNotification}
      />

      <ChangePasswordModal
        show={showChangePassword}
        setShowChangePassword={setShowChangePassword}
        onClose={() => {
          setCurrentPassword('')
          setPassword('')
          setConfirmPassword('')
          setError('')
          setShowChangePassword(false)
        }}
        setError={setError}
        vDetails={vDetails}
        password={password}
        setPasswordValid={setPasswordValid}
        setPassword={setPassword}
        passwordValid={passwordValid}
        onSubmit={() => onResetPasswordWithUser(backendUser?.id)}
        passwordChange={passwordChange}
        setPasswordChange={setPasswordChange}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
        handleErrorMessage={handleErrorMessage}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        confirmPasswordValid={confirmPasswordValid}
        setConfirmPasswordValid={setConfirmPasswordValid}
        onCurrentPasswordChange={onCurrentPasswordChange}
        onPasswordChange={onPasswordChange}
        onConfirmPasswordChange={onConfirmPasswordChange}
      />
      <InviteFriendsByEmailModal
        inviteUsersByEmail={inviteUsersByEmail}
        notify={notify}
        backendUser={backendUser}
        show={showInviteFriends}
        onClose={() => setShowInviteFriends(false)}
        partnerId={backendPartner?.id}
      />
      <FeedbackModal
        show={showFeedback}
        onClose={() => setShowFeedback(false)}
        onAdd={async (data: UserFeedback) => {
          const feedback = await createFeedback(data)
          handleAvatarClickTracker('Feedback submission', {
            'Feedback Category': feedback?.category,
            'Attached File': feedback?.attachment
          })
        }}
      />
    </StyledPageWrapper>
  )
}
